import { OrderUpsell } from '@models/order-upsell';

export class UpsellStoreRequest {
  public test_id: number;

  public constructor(orderUpsell: OrderUpsell) {
    this.test_id = orderUpsell.id;
  }
}
